import alt from 'components/Dispatcher';

class AdminWelcomeEmailActions {
  constructor() {
    this.generateActions(
      'selectItem',
      'selectAllItems',
      'sendWelcome',
      'sendWelcomeLoading',
      'sendWelcomeSuccess',
      'sendWelcomeError',
      'fetchUserList',
      'fetchUserListError',
      'fetchUserListSuccess'
    );
  }
}

export default alt.createActions(AdminWelcomeEmailActions);
